var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLind(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12789_58836)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.001 2.5C20.001 1.1202 18.8808 0 17.501 0H2.50098C1.12117 0 0.000976562 1.1202 0.000976562 2.5V17.5C0.000976562 18.8798 1.12117 20 2.50098 20H17.501C18.8808 20 20.001 18.8798 20.001 17.5V2.5Z",
    fill: "#2867B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73477 6.98047H2.38477V17.0571H5.73477V6.98047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.09227 2.12109C2.94613 2.12109 2.19727 2.87461 2.19727 3.86223C2.19727 4.8291 2.92336 5.6034 4.04793 5.6034H4.06957C5.23766 5.6034 5.96473 4.8291 5.96473 3.86223C5.94305 2.87461 5.23773 2.12109 4.09227 2.12109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9634 6.74219C12.1865 6.74219 11.3905 7.71941 10.9448 8.40582V6.97914H7.5957C7.64012 7.92434 7.5957 17.0557 7.5957 17.0557H10.9448V11.4282C10.9448 11.127 10.9664 10.8259 11.0552 10.6106C11.297 10.0091 11.8484 9.38594 12.7737 9.38594C13.9851 9.38594 14.4704 10.3103 14.4704 11.6643V17.0557H17.8197V11.2772C17.8197 8.18203 16.1671 6.74219 13.9634 6.74219Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12789_58836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLind);
export default __webpack_public_path__ + "static/media/lind.b9a815ac306344df607860ebbb3b36e8.svg";
export { ForwardRef as ReactComponent };